module.exports = __webpack_public_path__ + "img/Aliviado_Corpo_1.c21699ed.png";